export default "__VITE_ASSET__bs4X0lk4__"